import { useWizard } from "react-use-wizard";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import FacilityTypeStep from "../../../../../shared/wizard/steps/facilityTypeStep";
import tradeInSteps from "./tradeInSteps";

interface ITradeInStep_6 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  data: number[] | null;
  doublePrevStep: boolean;
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void;
}

const TradeInStep_6 = ({
  isNextStepDisabled,
  data,
  doublePrevStep,
  onChange,
  onReset,
}: ITradeInStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      doublePrevStep ? tradeInSteps.step_4.step : tradeInSteps.step_5.step
    );
    onReset(["selectedFacilityTypeIds"]);
  };

  const handleNextStep = () => {
    goToStep(tradeInSteps.step_7.step);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      onChange(
        data.filter((id) => id !== selectedId),
        "selectedFacilityTypeIds"
      );
      return;
    }
    onChange([selectedId], "selectedFacilityTypeIds");
  };

  return (
    <div>
      <FacilityTypeStep
        counterPage={{
          current: tradeInSteps.step_6.page,
          max: tradeInSteps.step_6.maxPage,
        }}
        numPage={tradeInSteps.step_6.page}
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        text="Сколько комнат будет в вашей новой квартире?"
        mode="default"
      />
    </div>
  );
};

export default TradeInStep_6;
